<h3 class="account-referral-page-title">{{ 'bring_a_friend' | translate }}</h3>
<figure *ngIf="imageUrl" class="account-referral-page-image">
  <img [src]="imageUrl" [attr.aria-label]="'bring_a_friend' | translate" />
</figure>
<div class="account-referral-page-texts">
  <span *ngFor="let textElement of referralTextElements" [ngStyle]="textElement.style">{{ textElement.text }}</span>
</div>
<div *ngIf="referralCode" class="account-referral-page-texts account-referral-page-coupon-container">
  <span class="account-referral-page-coupon-text">{{ 'your_referral_code_is' | translate }}</span>
  <span class="account-referral-page-coupon-code">{{ referralCode }}</span>
  <button
    mat-icon-button
    class="account-referral-page-coupon-copy"
    [matTooltip]="'copy_to_clipboard' | translate"
    matTooltipShowDelay="300"
    [attr.aria-label]="'button_for_referral_code_copy' | translate"
    ngxClipboard
    (cbOnSuccess)="onCopySuccess()"
    [cbContent]="referralCode"
  >
    <mat-icon fontSet="material-icons-round">copy</mat-icon>
  </button>
</div>
<div class="account-referral-page-texts">
  <span *ngIf="referralLimit" class="account-referral-page-limit"
    >{{ 'you_can_invite_up_to' | translate }} {{ referralLimit }} {{ 'friends_' | translate }}.</span
  >
</div>
